import React from "react";
import { ICON_TYPES } from "../../utils/constants";

const SimpleNotification = ({
    message = null,
    component = null,
    type,
    className = "",
    textClassName = "",
    marginBottom = "mb-4",
}) => {
    return (
        <div
            className={`flex gap-2 notification-alert py-2 px-4 rounded ${className} ${marginBottom}`}
        >
            {type && (
                <i
                    className={`fas fa-${ICON_TYPES[type]} text-xs text-primary-blue`}
                />
            )}
            {message && <p className={`text-xs ${textClassName}`}>{message}</p>}
            {component && { ...component }}
        </div>
    );
};

export default SimpleNotification;
